export const NUT_SPECS = [
  { id: "bsw", label: "BSW / BSF", standard: "INCH", system: "inches" },
  { id: "old", label: "OLD SPEC", standard: "IS 1363/67", system: "metric" },
  { id: "new", label: "NEW SPEC", standard: "IS 1363/92", system: "metric" },
];

const bswNuts = { "1/8": 122000, "5/32": 94300, "3/16": 37600, "1/4": 15500, "5/16": 9800, "3/8": 6121, "7/16": 3600, "1/2": 2250, "5/8": 1150, "3/4": 696, "7/8": 580, "1": 385, "1.1/8": 275, "1.1/4": 188, "1.3/8": 132, "1.1/2": 110, "1.3/4": 70, "2": 61, "2.1/4": 45, "2.1/2": 29, "2.3/4": 19, "3": 15 };
const oldNuts = { M2: 454550, M3: 151500, M4: 74075, M5: 45045, M6: 21551, M7: 17000, M8: 10373, M10: 4900, M12: 3144, M14: 2083, M16: 1623, M18: 1124, M20: 829, M22: 700, M24: 485, M27: 324, M30: 231, M33: 184, M36: 135, M39: 105, M42: 87, M45: 68, M48: 54, M52: 46, M56: 38, M60: 31, M64: 27, M72: 20, M80: 15, M90: 11, M100: 8 };
const newNuts = { "M10x16 A/F": 5500, "M12x18 A/F": 3600, M16: 1500, M20: 750, M22: 560, M24: 400 };

export const NUT_RATES = { bsw: bswNuts, old: oldNuts, new: newNuts };

function nutSize(s) {
  if (s.startsWith("M")) return parseFloat(s.slice(1));
  const mixed = s.match(/^(\d+)\.(\d+)\/(\d+)$/);
  if (mixed) return Number(mixed[1]) + Number(mixed[2]) / Number(mixed[3]);
  const frac = s.match(/^(\d+)\/(\d+)$/);
  if (frac) return Number(frac[1]) / Number(frac[2]);
  return Number(s);
}

export function getNutSizes(specId) {
  return Object.keys(NUT_RATES[specId] || {}).sort((a, b) => nutSize(a) - nutSize(b));
}

export function getNutRate(specId, size) {
  return NUT_RATES[specId]?.[size];
}
